<template>
  <main class="page" @click="goHome">
    <div class="identity ba-flex md:ba-items-center ba-pt-16 md:ba-pt-32">
      <div
        class="container ba-flex ba-justify-center ba-flex-wrap ba-py-10 ba-content-center md:ba-content-start"
      >
        <figure class="identity__logo ba-text-center ba-mb-8 md:ba-mb-36 md:ba-w-76 lg:ba-w-140">
          <img
            class="ba-mb-4 ba-w-48 md:ba-w-76 ba-inline"
            src="img/brand/white/logo.svg"
            alt="Logo"
          />
          <h1
            style="color: white"
            class="ba-text-xl md:ba-text-3xl ba-text-center"
          >{{ $t('accessDenied') }}</h1>
        </figure>
        <div
          class="identity__wrap ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start md:ba-py-18"
        >
          <b-btn @click="onLogout" class="text-white">{{ $t('tryAnotherUser') }}</b-btn>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import navUtils from "@/shared/nav-utils";

export default {
  name: "vis-access-denied",
  methods: {
    goHome() {
      navUtils.navigateToHome(this.$router);
    },
    onLogout() {
      this.$visIdentity.navigateToSignOut(this.$router);
    }
  }
};
</script>

<style>
.page {
  background-color: #2677e1;
  height: 100vh;
  cursor: pointer;
}
</style>
